<template lang="pug">
  transition(name="fade")
    #faceAssetList( ref="area")
      .feature.title
        .feature_key.title asset feature
        .feature_val.title asset name
      .feature(v-for="(value, key) in features")
          .feature_key {{ key }}
          .feature_val {{ value }}
            .swatch(v-if="hasColor(key)" :style="{ backgroundColor: '#' + value}")

</template>

<script>
  import {
    MODAL_STATES,
    PATHS,
    APP_NAME,
    GETTERS,
    ACTIONS,
    MUTATIONS,
    STATES
  } from 'src/config/app'
  import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
  import { TweenLite } from 'gsap'
  import {EVENTS, default as FaceFeatureService} from "src/services/FaceFeatureService/FaceFeatureService"
  import $ from "jquery"


  export default {
    name: 'AssetList',
    components: {
    },
    data() {
      return {
        hasData:false,
        features:{
          face_shape:'',
          skin_color:'',

          hat:'',
          hat_color:'',
          hair_front:'',
          hair_back:'',
          hair_color:'',

          glasses:'',
          eye_brows:'',
          eye_brow_color:'',
          eyes:'',
          eye_color:'',

          cheeks:'',
          nose:'',
          facial_hair_shadow:'',
          facial_hair:'',
          facial_hair_color:'',
          mouth:'',
          mouth_width:'',
          lip_color:'',
          chin_height:'',
          face_width:'',
          eye_brows_rotation:'',
        }
      }
    },
    props: {},
    computed: {
    },

    mounted() {
      FaceFeatureService.on(EVENTS.faceInfo, this.onFaceInfo)
    },

    beforeDestroy() {},

    methods: {
      ...mapMutations(APP_NAME, [
        MUTATIONS.setAppState,
        MUTATIONS.setModalState
      ]),

      hasColor(key){
        return (key.indexOf('color')> -1)
      },

      onFaceInfo(info){
        this.face_info = info
        this.hasData = !!this.face_info

        if(!this.hasData){return}

        let fa = FaceFeatureService.faceAssets

        let o = this.features

        o.cheeks = fa.cheeks
        o.eye_brows = fa.eye_brows
        o.eye_brow_color = fa.eye_brow_color
        o.eyes = fa.eyes
        o.face_shape = fa.face_shape
        o.facial_hair = fa.facial_hair
        o.facial_hair_color = fa.facial_hair_color
        o.facial_hair_shadow = fa.facial_hair_shadow
        o.glasses = fa.glasses
        o.hair_front = fa.hair_front
        o.hair_back = fa.hair_back
        o.hair_color = fa.hair_color
        o.hat = fa.hat
        o.hat_color = fa.hat_color
        o.mouth = fa.mouth
        o.nose = fa.nose
        o.skin_color = fa.skin_color
        o.eye_color = fa.eye_color
        o.lip_color = fa.lip_color
        o.mouth_width = fa.mouth_width
        o.chin_height = fa.chin_height
        o.face_width = fa.face_width
        o.eye_brows_rotation = fa.eye_brows_rotation
      },

    },

    watch: {
      face_info(){
        this.drawGeo()
      }
    },
  }
</script>

<style lang="sass">
  @import "src/styles/common.sass"

  #faceAssetList
    font-size: 11px
    background-color:  rgba(235,235,235,1.0)
    position: relative
    display: block
    text-align: left
    min-width: 100%
    width: 370px

    .mobile &
      font-weight: bold
      width: 100%

    .feature
      position: relative
      display: block
      line-height: 30px
      width: 800px

      &.title
        line-height: 40px


      .feature_key
        width: 130px
        text-align: right
        background-color: #cccccc
        position: relative
        display: inline-block
        padding: 0px 10px

        &.title
          color: white
          background-color: #000000

      .feature_val
        text-align: left
        position: relative
        display: inline-block
        padding: 0px 10px

        &.title
          color: white
          background-color: #3b3b3b
          width: 600px

        .swatch
          position: relative
          display: inline-block
          margin: 0px 10px
          background-color: rgba(0, 0, 0, 0.71)
          width: 24px
          height: 24px
          vertical-align: middle










</style>
